import React, { useContext } from 'react';
import { CanvasContext } from 'components/upload-image/CanvasContext';
import { FONT_DEFAULT_SIZE, FONT_DEFAULT_FAMILY } from 'constants/fonts';

export default function AddTextButton({ onAdd }) {
  const { setTextItems, setRedrawTrigger } = useContext(CanvasContext);

  const handleAddText = () => {
    const newItem = {
      id: crypto.randomUUID?.() ?? String(Date.now()),
      x: 50,
      y: 50,
      text: '',
      color: '#000000',
      fontFamily: FONT_DEFAULT_FAMILY,
      fontSize: FONT_DEFAULT_SIZE, // per-item default
    };

    setTextItems((prev) => {
      const next = [...prev, newItem];
      const newIndex = next.length - 1;
      if (onAdd) setTimeout(() => onAdd(newIndex), 0); // let parent select & edit
      return next;
    });

    setRedrawTrigger((prev) => prev + 1);
  };

  return (
    <button
      type="button"
      className="mt-2 px-4 py-2 bg-primary text-white rounded hover:bg-stone-800 snap-center scroll-ml-4"
      onClick={handleAddText}
    >
      <span className="font-bold">+</span> Add another text box
    </button>
  );
}
